// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/sidebar/sidebar.scss
// module id = 531
// module chunks = 0